
(function () {
    'use strict';
    var controllerId = 'home';
    angular.module('appHome').controller(controllerId, ['$rootScope', '$translate', home]);

    function home($rootScope, $translate) {

        var vm = this;
        vm.currentLanguage = $translate.use() || $translate.proposedLanguage();

        $translate.use(vm.lingua);

        if (vm.lingua == 'undefined' || !vm.lingua) {
            vm.lingua = vm.currentLanguage;
        }

        //console.info('lingua2', vm.currentLanguage);

        vm.changeLanguage = changeLanguage;
        vm.setLanguage = setLanguage;

        function changeLanguage() {
            $translate.use(vm.lingua);
            cookie();
        }

        function setLanguage(language) {
            vm.lingua = language;
            $translate.use(vm.lingua);
            cookie();
        }

        function getLanguage() {            
            return $translate.use();            
        }

        function cookie() {
            $("#uecookielaw").html(''); 
            
            //inizio cookie
            var cookieName = 'user_accepts_cookies';
            var valore = $.cookie(cookieName) || null;
            if (valore == null) {
                var link = "/informativa-cookie_" + vm.lingua + ".htm";
                if (vm.lingua == 'it') {
                    $("#uecookielaw").html("<div id='cookielawwrap'><h1>Cookie</h1><h3><span class='cookielaw-hidden'>Utilizziamo i cookie per migliore la tua esperienza sul nostro sito.<br />Quando utilizzi il nostro sito web, accetti che vengano trasmessi cookie sul tuo dispositivo.</span> <a href='" + link + "' target='_blank'>Ulteriori informazioni</a></h3><div id='uecookielawclose' class='accept'>Accetto</div></div>");
                }
                else {
                    $("#uecookielaw").html("<div id='cookielawwrap'><h1>Cookie</h1><h3><span class='cookielaw-hidden'>We use cookies to improve your experience on our site.<br />When you use our website, you agree to be sent cookies to your device.</span> <a href='" + link + "' target='_blank'>More info</a></h3><div id='uecookielawclose' class='accept'>Accept</div></div>");
                }                
                $("#uecookielaw").addClass("cookielaw");
                $("#uecookielaw").show();
            }
            $("#uecookielawclose").click(function () {
                $.cookie(cookieName, "Normativa letta", { expires: 30, path: '/' });
                $("#uecookielaw").hide();
            });

            //fine cookie    */        
        }
   }
})();
